<template>
    <div>
        <div class="cms-flex--between mg-b--15">
            <div class="cms-page-title mg-b--0">Net Audio</div>
        </div>

        <search-form :form-list="searchConfig.formList" :form-data="searchConfig.formData" :size="searchConfig.size"
         @search="search" @reset="reset" :gutter="50"></search-form>
        <div ref="m-table" class="table-box">
            <section>
                <div class="cms-card-block">
                    <div slot="header" class="cms-flex--between mg-b--15" >
                        <div>
                            <el-button class="cms-op-btn cms-op-btn-main" @click="Add">{{ $t('新增') }}</el-button>
                            <el-button class="cms-op-btn cms-op-btn-main" @click="removeSelect">{{ $t('删除') }}</el-button>
                            <el-button class="cms-op-btn cms-op-btn-main" :disabled="!tableDataConfig.selectList.length"
                                @click="onlineSelect">{{ $t('上线') }}</el-button>
                            <el-button class="cms-op-btn cms-op-btn-main" :disabled="!tableDataConfig.selectList.length"
                                @click="offlineSelect">{{ $t('下线') }}</el-button>
                            <el-button class="cms-op-btn cms-op-btn-main" @click="openExcelImportDialog">{{ $t('导入') }}</el-button>
                        </div>
                        <!-- <div>
                            <span style="padding-right:15px ;">{{ $t('盒端置顶显示') }}</span>
                            <el-switch v-model="onOff" @change="changeSwitch"></el-switch>
                        </div> -->
                    </div>
                    <div class="show-table">
                        <el-table :data="tableDataConfig.data" size="default" border :height="null"
                            v-loading="tableDataConfig.loading" header-row-class-name="tableheader"
                            @selection-change="changeFun" tooltip-effect="light" style="width: 100%">
                            <el-table-column  type="selection"
                                width="55" />
                            <el-table-column  prop="showNo" label="No."
                                width="120">
                                <template #header>
                                    <div class="tip_title">
                                        <span>{{ $t('No.') }}</span>
                                        <el-tooltip class="box-item" effect="light" :content="t('Double click to edit')"
                                            placement="top">
                                            <el-icon color="#F56C6C" :size="16" class="mg-l--5 transform_icon">
                                                <warning />
                                            </el-icon>
                                        </el-tooltip>
                                    </div>
                                </template>
                                <template #default="scope">
                                    <DbClickInput v-model="scope.row.showNo" @focus:modelValue="savaShowNo(scope.row.showNo)"
                                        @valueChange="(val, done) => { toEditShowNo(scope.row, val, done) }">
                                    </DbClickInput>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column show-overflow-tooltip prop="showNo" label="No." width="120" /> -->
                            <el-table-column prop="channelName" show-overflow-tooltip :label="$t('节目名称')">
                                <template #default="scope">
                                    <!-- <el-image
                                        v-if="scope.row.logo != null"
                                        class="logo"
                                        :src="scope.row.logo"
                                        :preview-src-list="scope.row.logoList"
                                        fit="cover"
                                        :append-to-body="true"
                                    ></el-image>    -->

                                    <viewer style="display: initial;" v-if="scope.row.logo != null"
                                        :images="scope.row.logoList">
                                        <img class="logo" :src="scope.row.logo" />
                                    </viewer>
                                    <div class="logo" v-else></div>
                                    <span>
                                        <p v-text="scope.row.channelName" class="channelName"></p>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="channelUrl" label="URL" min-width="150%" />
                            <el-table-column prop="props" label="Satellite:TP:SID">
                                <template #default="scope">
                                    <span>{{scope.row.satellite?scope.row.satellite:'--'}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="createTime" :label="$t('创建时间')">
                                <template #default="scope">
                                    <span>{{ getCurrentTime(scope.row['createTime']) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column  fixed="right" :label="$t('操作')" width="200px">
                                <template #default="scope">
                                    <span class="link" style="margin-right:10px" @click="editing(scope.row)">{{$t('编辑')}}</span>
                                    <span class="link" style="margin-right:10px" @click="remove(scope.row)">{{$t('删除')}}</span>
                                    <el-button size="default" :disabled="scope.$index == 0" type="primary" link
                                        @click="sortRow(scope.row, scope.$index, 0)">
                                        <img :class="scope.$index !== 0 ? '' : 'disabled'"
                                            src="~@/assets/imgs/icon_moveup.png" />
                                    </el-button>
                                    <el-button size="default" type="primary" link @click="sortRow(scope.row, scope.$index, 1)"
                                        :disabled="tableDataConfig.data.length == 1 || scope.$index == tableDataConfig.data.length - 1">
                                        <img :class="!(tableDataConfig.data.length == 1 || scope.$index == tableDataConfig.data.length - 1) ? '' : 'disabled'"
                                            src="~@/assets/imgs/icon_movedown.png" />
                                    </el-button>
                                </template>

                            </el-table-column>
                        </el-table>
                        <div class="block">
                            <el-pagination ref="page" @size-change="handleSizeChange" @current-change="handlePagination"
                                :current-page="tableDataConfig.page.page || 1" :page-sizes="[10, 20, 40, 100]"
                                :page-size="tableDataConfig.page.limit || 10"
                                :total="Number(tableDataConfig.page.totalNum) || 0"
                                layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <!-- 弹框 -->
        <m-dialog v-model="dialogVisible" :options="dialogOptions"
            :showConfirm="dialogOptions.showConfirm" @on-confirm="confirm" autoLoading :dialogConfig="dialogOptions">
            <template #default>
                <div class="mform">
                    <el-form ref="AddForm" label-width="150px" :rules="actionForm.rules" :model="actionForm.audio">
                        <el-form-item prop="logo" :label="$t('图标')">
                            <!-- <upload ref="uploadLogo" :fileName="'logo'" listType="picture" :isShowBtn="false"
                                :fileList="actionForm.photoList" @onChange="fileChange" :accept="'.jpg'"
                                v-model:fileList="actionForm.photoList"
                            
                                >
                                <template #uploadSolt>
                                    <div>
                                        <el-button type="primary">{{ $t('上传') }}</el-button>
                                        <span style="font-size: 10px; padding-left: 5px;">jpg files with a size less
                                            than 200kb</span>
                                    </div>
                                </template>
                            </upload> -->
                            <el-input v-model="actionForm.audio.logo" ></el-input>
                        </el-form-item>
                        <el-form-item prop="channelName" :label="$t('节目名称')">
                            <el-input v-model="actionForm.audio.channelName" :disabled="actionForm.disabled"
                                :placeholder="$t('请输入节目名称')"
                                maxlength="64"></el-input>
                        </el-form-item>
                        <el-form-item prop="channelUrl" label="URL">
                            <el-input v-model="actionForm.audio.channelUrl" :disabled="actionForm.disabled" type="textarea"
                                :placeholder="`${$t('请输入')} url`"
                                :autosize="{ minRows: 1, maxRows: 2 }"></el-input>
                        </el-form-item>
                        <el-form-item prop="satellite" label="Satellite">
                            <el-input v-model="actionForm.audio.satellite" :disabled="actionForm.disabled"
                            placeholder="Satellite:TP:SID(eg:192:10729:30803)"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </template>
        </m-dialog>
    </div>
</template>

<script>
import upload from './upload.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { elMessage } from "@/utils";
import { reactive, ref, defineComponent, getCurrentInstance, computed, watch } from 'vue'
export default defineComponent({
    name: 'netAudio',
})
</script>
<script setup >
import { useI18n } from 'vue-i18n'
import { nextTick, onMounted, watch } from 'vue'
import { getCurrentTime } from '@/utils/timeFormat'
import { useExcelImport } from '@/utils/useExcelImport'
import DbClickInput from "./dbClickInput.vue"
import { getNetAudioListApi, deleteNetAudioApi, addNetAudioApi, editNetAudioApi, editNetAudioShwoNoApi } from '@/api/live'


const { locale, t } = useI18n()
const { emit } = getCurrentInstance()
const AddForm = ref(null)
const user = ref({
      name: 'white',
      permissionKey: ['PLNM'],
      roles: [],
      identity: [],
      cid: [],
      model: []
})
const dialogType = ref(1)
const dialogVisible = ref(false)
const dialogOptions = reactive({
    showConfirm: true,
    destroyOnClose: true
})
const formData = reactive({})
const formList = reactive([
    {
        prop: 'channelName',
        label: '节目名称',
        type: 'input',
        placeholder: t('请输入节目名称'),
        disabled: false
    }
])

const searchConfig = reactive({
  size: { sm: 24, md: 12, lg: 8, xl: 6, xs: {} },
  formList: [
    { label: '节目名称', prop: 'channelName', widgetType: 'input' , valueKey: 'cid', labelKey: 'prefixName'}
  ],
  formData: {
    channelName:''
  }
})

const tableDataConfig = reactive({
    data: [],
    selectList: [],
    showNo: {},
    isUpadata: false,
    loading: false,
    page: {
        page: 1,
        limit: 10,
        totalNum: 0
    }
})

// 上下线接口暂未提供，先保留选中项 ID 和状态处理入口。
const changeReleaseState = (state) => {
    const idList = tableDataConfig.selectList.map(item => item.id)
    if (!idList.length) return
    // 接口提供后在此提交 idList；state 为 1 表示上线，2 表示下线。
}

const onlineSelect = () => changeReleaseState(1)
const offlineSelect = () => changeReleaseState(2)

// 暂存导入文件，待接口提供后用于提交。
const netAudioImportFile = ref(null)

// Net Audio 导入接口占位；接口提供后替换为真实 API 请求。
const importNetAudioRequest = async (_formData) => {
    return { code: 'PENDING' }
}

// 预设文件选择、请求、加载状态和成功刷新流程。
const { openExcelImportDialog } = useExcelImport({
    request: importNetAudioRequest,
    setLoading: (value) => {
        tableDataConfig.loading = value
    },
    onFileSelected: (file) => {
        netAudioImportFile.value = file
    },
    onSuccess: async () => {
        tableDataConfig.page.page = 1
        await getNetAudioList()
    }
})

onMounted(()=> {
  getNetAudioList()
})

const props = defineProps({
    cid: {
        type: String,
        default: '-1'
    }
})

const search = () => {
    getNetAudioList()
}

const reset = () => {
    getNetAudioList()
}

const handleSizeChange = (val) => {
    tableDataConfig.page.limit = val
    getNetAudioList()
}

const handlePagination = (val) => {
    tableDataConfig.page.page = val
    getNetAudioList()
}

const Add = () => {
    actionForm.audio = {}
    if (user.value.roles.indexOf('VNO') > -1) {
        props.cid = user.value.cid[0]
    }
    actionForm.photoList = []
    dialogType.value = 1
    dialogOptions.title = '新增音频'
    dialogVisible.value = true
    dialogOptions.width = '45%'
}

const editing = (row) => {
    actionForm.audio = Object.assign({}, row)
    actionForm.photoList = []
    if (actionForm.audio.logo != null) {
        actionForm.photoList.push({ name: 'logo', url: actionForm.audio.logo })
    }
    dialogType.value = 2
    dialogOptions.title = '编辑音频'
    dialogVisible.value = true
    dialogOptions.width = '45%'
}

const confirm = async (done) => {
    AddForm.value.validate(async (valid) => {
        if (valid) {
            if (dialogType.value == 1) {
                //actionForm.photoList里面有上传的图片数据，看接口到时候要传什么就从里面找
                const {code} = await addNetAudioApi(actionForm.audio)
                if(code==0) {
                    done()
                    ElMessage({ message: t("添加成功"), type: 'success'})
                    getNetAudioList()
                } else {
                   ElMessage({ message: t("添加失败"), type: 'success'})
                }
            } else if (dialogType.value == 2) {
                const {code} = await editNetAudioApi(actionForm.audio)
                if(code==0) {
                    done()
                    ElMessage({ message: t("更新成功"), type: 'success'})
                    getNetAudioList()
                } else {
                   ElMessage({ message: t("添加失败"), type: 'success'})
                }
            }
            dialogVisible.value = false
        } else {
            done()
        }
    })
    
}

const removeSelect = () => {
    var names = tableDataConfig.selectList.map(item => item.channelName)
    var ids = tableDataConfig.selectList.map(item => item.id)
    if (ids != null && ids.length > 0) {
        ElMessageBox.confirm(
            t('是否要删除音频：') + names.toString() + '?',
            t('Warning'),
            {
                confirmButtonText: t('是的，确定'),
                cancelButtonText: t('不，取消'),
                closeOnClickModal: false

            }
        )
            .then(() => {
                deleteNetAudioApi(ids).then(res => {
                    if (res.code == 0) {
                        ElMessage({
                            message: t('删除成功'),
                            type: 'success',
                        })
                        getNetAudioList()
                    } else {
                        ElMessage({
                            message: t('删除失败'),
                            type: 'error',
                        })
                    }
                })
            })
            .catch(() => {
                elMessage('info', '已取消')
            })
    } else {
        elMessage('warning', '请至少选择一项')
    }

}
const remove = (row) => {
    ElMessageBox.confirm(
        t('是否要删除音频：') + row.channelName + '?',
        t('Warning'),
        {
            confirmButtonText: t('是的，确定'),
            cancelButtonText: t('不，取消'),
            closeOnClickModal: false
        }
    )
        .then(() => {
            deleteNetAudioApi([row.id]).then(res => {
                if (res.code == 0) {
                    ElMessage({
                        message: t('删除成功'),
                        type: 'success',
                    })
                    getNetAudioList()
                } else {
                    ElMessage({
                        message: t('删除失败'),
                        type: 'error',
                    })
                }
            })
        })
        .catch(() => {
            elMessage('info', '已取消')
        })
}

const sortRow = (row, index, type) => {
    const i = type == 0 ? row.showNo - 1 : row.showNo + 1
    editNetAudioShwoNoApi(row.id, i).then((res) => {
        if (res.code == 0) {
            ElMessage({
                message: t("更新成功"),
                type: 'success',
            })
            getNetAudioList()
        } else {
            ElMessage({
                message: t("更新失败"),
                type: 'error',
            })
        }
    })
}

const toEditShowNo = async (row, val, done) => {
    const reg = /^[1-9]\d*$/
    if (row.no != row.showNo) {
        if (reg.test(row.no) && row.no > 0 && row.no <= tableDataConfig.page.totalNum) {
            var serialNo
            if (row.no < row.showNo) {
                serialNo = Number(row.showNo) + (Number(row.showNo) - Number(row.no))
            } else {
                serialNo = Number(row.showNo) - (Number(row.no) - Number(row.showNo))
            }
            editNetAudioShwoNoApi(row.id, val).then(res=> {
                if (res.code == 0) {
                    ElMessage({
                        message: t("更新成功"),
                        type: 'success',
                    })
                    done()
                    getNetAudioList()
                } else {
                    ElMessage({
                        message: t("更新失败"),
                        type: 'error',
                    })
                }
            })
            // editShowNo({ cid: row.cid, id: row.id, showNo: row.showNo, serialNo: serialNo }).then(res => {
            //     if (res.code == 0) {
            //         ElMessage({
            //             message: t("更新成功"),
            //             type: 'success',
            //         })
            //         done()
            //         getNetAudioList()
            //     } else {
            //         ElMessage({
            //             message: t("更新失败"),
            //             type: 'error',
            //         })
            //     }
            // })
        } else {
            setShowNo(row)
            ElMessage({
                message: t("No.必须是大于0的整数,且不能大于列表总数"),
                type: 'error',
            })
        }
    } else {
        done()
    }

}

// const changeSwitch = (val) => {
//     var sort = val ? 1 : 0
//     switchNetAudio({ cid: props.cid, sort: sort })
// }

const setShowNo = (row) => {
    setTimeout(() => {
        if (!tableDataConfig.isUpadata) {
            row.no = tableDataConfig.showNo
        }
    }, 500);
}

const savaShowNo = (val) => {
    tableDataConfig.showNo = val
    tableDataConfig.isUpadata = false
}

const changeFun = (val) => {
    tableDataConfig.selectList = val
}

const getFileType = (name) => {
    let startIndex = name.lastIndexOf('.')
    if (startIndex !== -1) {
        return name.slice(startIndex + 1).toLowerCase()
    } else {
        return ''
    }
}

const fileChange = (file) => {
    console.log('上传',file)
    console.log('图片列表',actionForm.photoList)

    let suffix = getFileType(file.name) //获取文件后缀名
    let suffixArray = ['jpg']  //限制的文件类型，根据情况自己定义
    if (suffixArray.indexOf(suffix) === -1) {
        actionForm.photoList = []
        ElMessage({
            message: t('文件格式错误'),
            type: 'error',
            duration: 2000
        })
        return false
    }

    if (file.size / (1024) > 200) {   // 限制文件大小
        elMessage('warning', `当前限制文件大小不能大于200K`)
        actionForm.photoList = []
        return false
    }

    return suffixArray
}

const validateUrl = (rule, value, callback) => {
    const reg = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/

    if (value == undefined || value === '') {
        callback(new Error(t('url不能为空')))
    } else if (!reg.test(value)) {
        callback(new Error(t('URL必须以 (https|http|ftp|rtsp|mms)://) 开头')))
    } else if (value.length > 256) {
        callback(new Error(t('url的长度不能超过256')))
    } else {
        callback()
    }
}

const validateCid = (rule, value, callback) => {

    const reg = /^[1-9]\d*$/
    if (value == undefined || value === '') {
        callback(new Error(t('cid不能为空')))
    } else if (reg.test(value)) {
        callback()
    } else {
        callback(new Error(t('cid必须为大于0的整数')))
    }
}

const validateName = (rule, value, callback) => {
    if (value == undefined || value === '') {
        callback(new Error(t('名称不能为空')))
    } else if (value.length > 50) {
        callback(new Error(t('节目名称的长度不能超过50')))
    } else {
        callback()
    }
}

const validStatelite = (rule,value,callback) => {
  //正则: 卫星角度(0,4000) : 频点频率(0,20000) : 节目sid(0,99999)
  const reg = /^(3999|(\d|[1-9]\d{1,2}|[1-2]\d{3}|3\d\d\d)):(19999|(1\d{4}|([1-9]\d{0,3}))):(99999|(\d|[1-9]\d{1,4}))$/
  if(!value || value.trim()=== '') return callback()
  let arr = value.trim().split(';')
  let word = rule.field === "satelliteToIPTV"?'卫星转IPTV参数的格式为':'EPG参数的格式为'
  if(arr.length > 1){
    // 有多条数据的情况
    let suitableArr = arr.filter(item=> reg.test(item))
    if(suitableArr.length!==arr.length){
      // return callback(new Error(`${t(word)}: 1111:11111:11111`))
      return callback(new Error(t('格式错误')))
    } else {
      callback()
    }
  } else {
    // 只有一条数据
    if(!reg.test(value)){
      // return callback(new Error(`${t(word)}: 1111:11111:11111`))
      return callback(new Error(t('格式错误')))
    } else {
      callback()
    }
  }

}

const actionForm = reactive({
    audio: {
        // logo:[]
    },
    photoList: [],
    disabled: false,
    formlist: [

    ],
    rules: {
        cid: [{ required: true, validator: validateCid, trigger: 'blur' }],
        channelName: [{ required: true, validator: validateName, trigger: 'change' }],
        channelUrl: [{ required: true, validator: validateUrl, trigger: 'change' }],
        satellite: [{ validator: validStatelite, trigger: 'blur' }],
    },
})


// 请求netAudio列表
const getNetAudioList = async () => {
  const {code, data} = await getNetAudioListApi(tableDataConfig.page.page, tableDataConfig.page.limit, searchConfig.formData.channelName)
  if(code==0) {
    tableDataConfig.data = data.records.map((item, index) => {
        return {
            ...item,
            no: (tableDataConfig.page.page - 1) * tableDataConfig.page.limit + index + 1,
            logoList: [item.logo]
        }
    })
    tableDataConfig.page.totalNum = data.total
  }
}
</script>

<style lang="less" scoped>
.channelName {
    display: inline;
    overflow: hidden;
    text-overflow: ellipsis;
}

.disabled {
    filter: sepia(0.8);
}

.tableheader {
    background-color: var(--table-header-bg) !important;
    color: var(--table-header-color);
    font-size: 14px;
}

.logo {
    width: 24px;
    height: 24px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    margin-right: 15px;
}

.arrows {
    vertical-align: middle;
    font-size: 17px;
    font-weight: bold;
}

.btn-box {
    display: inline;
    margin-left: 15px;
}

.el-pagination {
    justify-content: flex-end;
    text-align: right;
    padding: 20px;
}

.mform {
    .el-form {
    border: 1px solid #e3e7ed;
    .el-form-item {
      margin-bottom: 0px;
      border: 1px solid #e3e7ed;
      // height: 98%;
    }
    :deep(.el-form-item__label) {
      height: inherit;
      display: flex;
      align-items: center;
      text-align: left;
      justify-content: flex-start;
      border-right: 1px solid #e3e7ed;
      padding: 10px;
      background-color: var(--form-label-bgColor);
    }
    :deep(.el-form-item__content) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      // align-items: center;
      padding: 15px !important;
      overflow: auto;
      .el-form-item__error{
        position: unset;
        align-self: flex-start;
      }
    }
  }

    .add-ids {
        display: flex;
        margin: 5px 0px;

        .el-input {
            width: 200px;
            margin-right: 10px;
        }
    }
}

.num-class {
    display: flex;
    flex-direction: column;
    justify-content: center;

    div {
        display: flex;
        align-items: center;

        span {
            display: inline-block;
            margin: 5px 0px;
            width: 50px;
        }
    }
}

.show-table {
    :deep(.el-table__fixed-right) {
        right: 0px !important;
    }
    .btn-box {
        display: inline;
        margin-left: 15px;
    }

    .table-box {
        margin: 0 15px;
    }

    .el-pagination {
        text-align: right;
        padding: 20px;
    }

    &:deep(th.el-table__cell) {
        background: none !important;
    }

    .el-table--border .el-table__cell {
        border-right: none;
    }

    &:deep(.el-table--scrollable-y .el-table__body-wrapper) {
        scrollbar-width: thin;
    }

}
</style>
<style>

.tip_title {
    display: flex;
    align-items: center;
}

.tableheader {
    background-color: var(--table-header-bg) !important;
    color: var(--table-header-color);
    font-size: 14px;
}
</style>